import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private emitFunction = new Subject<void>();
  private emitDataSubjectToRefreshTable = new Subject<void>();
  private dataSubject = new BehaviorSubject<any>(null);
  data$: Observable<any> = this.dataSubject.asObservable();
  dataSubjectFunction$: Observable<any> = this.emitFunction.asObservable();
  dataSubjectToRefreshTable$: Observable<any> = this.emitDataSubjectToRefreshTable.asObservable();
  private communicationData: { [key: string]: any } = {};

  emitFunctionCall(): any {
    this.emitFunction.next();
  }

  getFunctionCall(): any {
    return this.emitFunction.asObservable();
  }
  sendDataConfigToTable(data: any): void {
    this.emitDataSubjectToRefreshTable.next(data);
  }
  sendData(data: any): void {
    this.dataSubject.next(data);
  }

  setData(id: string, data: any): void {
    this.communicationData[id] = data;
  }

  getData(id: any): any {
    return this.communicationData[id];
  }

  resetData(): void {
    this.communicationData = {};
  }
}
